import React, { useState } from "react";
import CardDiv from "modules/common/card-div/CardDiv";
import { Button, Modal, CloseButton } from "react-bootstrap";
import { Select } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { isEmpty } from "lodash";
import { Upload } from "antd";
import { useUpdateOrdersStore } from "modules/order_management/store";
import { useToast } from "modules/navbar/top/store/toasterStore";

function UpdateOrders() {
  const [modalShow, setModalShow] = useState(false);
  const [fileData, setFileData] = useState({});
  const [orderStatus, setOrderStatus] = useState(null);
  const [fileListArray, setFileListArray] = useState([]);
  const {updateOrderStatus}=useUpdateOrdersStore();
  const {setToaster}= useToast();


  const handleUpload=()=>{
    let file = new FormData();
    file.append("file", fileData);
    updateOrderStatus(orderStatus, file, setToaster)
    setOrderStatus(null);
    setFileData([]);
    setFileListArray([]);
    setModalShow(false);
  }



  const beforeUpload = (file) => {
    if (file.type !== "text/csv" && file.type !== "application/vnd.ms-excel") {
      message.error(`only csv file allowed`, 2);
      return true;
    }
    return false;
  };

  const handleFileUpload = (info) => {
    if (info.fileList.length !== 0) {
      setFileListArray(info.fileList);
      setFileData(info.file);
    }
  };

  const resetFile = () => {
    setFileListArray([]);
    setFileData({});
  };

  const handleModalShow=()=>{
    setOrderStatus(null);
    setFileData([]);
    setFileListArray([]);
    setModalShow(false);
  }

  return (
    <div>
      <CardDiv
        title={<div className="fs-2 ">Update Orders</div>}
        component={
          <div className="text-center" style={{ height: "20rem" }}>
            <div className="flex gap-2">
              <Button type="primary" onClick={() => setModalShow(true)}>
                Upload
              </Button>
            </div>
            <div className="fw-bold mt-3">
              RTO/Delivered Orders/Cancel Orders/Lost Damaged/Update Fulfillment
            </div>
          </div>
        }
      />
      <Modal
        show={modalShow}
        onHide={handleModalShow}
        size="md"
        aria-labelledby="contained-modal-title-vtop"
        top
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            Edit Rep Target
          </Modal.Title>
          <CloseButton
            className="btn btn-circle btn-sm transition-base p-0"
            onClick={handleModalShow}
          />
        </Modal.Header>
        <Modal.Body>
          <div>
            <div>
             <CardDiv title={ <p>Instructions to upload csv file:</p>}
             component={ <ol className="">
                <li>
                  Order Delivered Date or RTO Date should be in{" "}
                  <div className="text-danger">MM/DD/YYYY</div>format.
                </li>
                <li>
                  For cancelling the order select{" "}
                  <strong>Mark Order Cancelled.</strong>
                </li>
              </ol>}/>
            </div>
            <div className="d-flex mt-1 flex-column gap-2 card p-3 align-items-center">
              <Select
                onChange={(e) => setOrderStatus(e)}
                value={orderStatus}
                style={{ width: "50%" }}
                allowClear
                placeholder="Select"
                options={[
                  {
                    label: "Mark RTO Void",
                    value: "rto",
                  },
                  {
                    label: "Mark Delivered",
                    value: "delivered",
                  },
                  // {
                  // 	label: "Mark Order Cancelled",
                  // 	value: "cancel",
                  // },
                  {
                    label: "Mark Cancelled",
                    value: "sub_status_cancel",
                  },
                  {
                    label: "Mark Lost Damaged",
                    value: "lost_damaged",
                  },
                  {
                    label: "Update Fulfillment",
                    value: "update_fulfillment",
                  },
                  {
                    label: "Prozo Bulk Assignment",
                    value: "bulkAssignmentToProzo",
                  },
                  {
                    label: "Mark Delivered And Send Waba",
                    value: "markandsenddeliveredorderwaba",
                  },
                ]}
              />
              <Upload
                name="file"
                accept=".csv"
                className="mt-4 text-center"
                beforeUpload={(file) => beforeUpload(file)}
                onChange={handleFileUpload}
                maxCount={1}
                onRemove={resetFile}
                fileList={fileListArray}
              >
                <Button className="btn btn-primary-outline"  type icon={<UploadOutlined />}>Add File</Button>
              </Upload>
              <Button
                className="w-max mt-4"
                disabled={isEmpty(fileData) || !orderStatus}
                onClick={handleUpload}
                type="primary"
              >
                Upload
              </Button>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleModalShow}>Close</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default UpdateOrders;
